'use client';

import { SystemIcon } from '@wishket/design-system';

import NewLandingTitle from '../../NewLandingTitle/NewLandingTitle';

import { Link } from '@/shared/Components';
import { PATH } from '@/shared/constants';
import { useProfile } from '@/shared/hooks';

const Title = () => {
  const { profile } = useProfile();

  return (
    <Link
      href={PATH.AUTHORS}
      className="flex w-fit items-center gap-1.5"
      data-testid="landing-trending-author-title-link"
    >
      <NewLandingTitle
        title={profile ? '이 작가 궁금하세요?' : '요즘 뜨는 작가'}
      />
      <SystemIcon name="medium_arrow_right" className="text-w-gray-900" />
    </Link>
  );
};

export default Title;
